import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import {platformBrowser} from "@angular/platform-browser";
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import {ThermostatcheckModule} from "./app/thermostatcheck/thermostatcheck.module";

Sentry.init({
  dsn: "https://fc4bdc25ca064d38af8c951fa327a856@sentry.co2online.de/10",
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'fetch' && breadcrumb.data && breadcrumb.data.url && breadcrumb.data.url.match(/^data/)) {
      return null;
    }
    return breadcrumb;
  },

  enabled: environment.production === true,

  environment: window.location.host.indexOf('-dev') > 0? 'stage' : 'production',

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Sentry.setTag('page_locale', navigator['browserLanguage'] ?? navigator.language);

if (environment.production) {
  enableProdMode();
}

platformBrowser().bootstrapModule(ThermostatcheckModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
